import EnumBase from './Base';

export default function genderEnum(){
  return new EnumBase([
    { id: 'male', name: 'Macho' },
    { id: 'female', name: 'Fêmea' },
  ]);
}
